import ILocationService = angular.ILocationService;
import IFilterService = angular.IFilterService;
import {IStateService} from "angular-ui-router";
import {UrlService} from "../../../../services/urlService";
import * as _ from 'lodash';

const moment: any = require("moment");
require('./orders.less');

class OrdersController {
    datesInWeek;
    showDetails: boolean = false;
    promise;
    canConfirmOrder: boolean;
    yearSelectOptions = [];
    defaultSearchParams = {
        statuses: ['STANDARD'],
        deliveryDateFrom: null,
        deliveryDateTo: null,
        pageSize: 100,
        pageNo: 0,
        sort: "vip|desc,orderNo|asc"
    };
    activeSearchParams = {
        statuses: ['STANDARD'],
        deliveryDateFrom: null,
        deliveryDateTo: null,
        pageSize: 100,
        pageNo: 0,
        sort: "vip|desc,orderNo|asc"
    };

    //--- Searchform-definition ------------------------------------------------
    searchDefinition = {
        fields: [
            {type: 'week-select'},
            {title: 'Ordre', name: 'orderNo', type: 'number'},
            {title: 'Kunde', name: 'customerNameOrId', type: 'text'},
            {
                title: 'Status', name: 'statuses', type: 'select', multiple: true, options: [
                    {value: "STANDARD", display: "Standard"},
                    {value: "ON_HOLD", display: "Ordre på vent"},
                    {value: "CONFIRMED", display: "Bekreftet"},
                    {value: "FOR_PICKING", display: "Til plukking"},
                    {value: "PACKED", display: "Pakket"},
                    {value: "INVOICE_BASIS", display: "Fakturagrunnlag"}
                ]
            },
            {title: 'Vare', name: 'articleNameOrId', type: 'text'}
        ],
        searchParams: Object.assign({}, this.defaultSearchParams),
        searchFunction: (paramsWithFormattedDates) => this.ordersSearch(paramsWithFormattedDates),
        preDefinedSearches: [
            {title: "Splittede", ligature: "call_split", func: () => this.getSplitOrders(), name: 'splitOrders'},
            {
                title: "Kan ikke leveres",
                ligature: "report_problem",
                func: () => this.getCantDeliverOrders(),
                name: 'cantDeliverOrders'
            },
        ],
        useWeekSelect: true,
        useDefaultAllWeeks: true
    };

    //--- Toolbarheader-definition ------------------------------------------------
    toolbarheaderDefinition = {
        isTable: true,
        toolbarHeading: "Ordreoversikt",
        buttons: [
            {
                func: () => {
                    this.searchDefinition.searchParams = Object.assign({}, this.defaultSearchParams)
                    this.emptyWeekData();
                }, tooltip: "Slett søkedata", materialicon: "delete_sweep"
            },
        ],
    };


    //--- Table-definition ---------------------------------------------------

    iconColumn = {title: '', name: '', noOrderBy: true};
    tableDefinition = {
        columns: [
            this.iconColumn,
            this.iconColumn,
            this.iconColumn,
            {title: 'Ordre', name: 'orderNo'},
            {title: 'Kunde', name: 'customerNoAndName'},
            {title: 'Ønsket levering', name: 'requestedDeliveryDate'},
            {title: 'Tilgjengelig', name: 'availableDate', noOrderBy: true},
            this.iconColumn,
            {title: 'Leveringsdato', name: 'deliveryDate'},
            {title: 'Sum ordre', name: 'totalAmount', type: "number", noOrderBy: true},
            {title: 'Frakt %', name: 'freightCostPer', noOrderBy: true},
            {title: 'VIP', name: 'vip'},
        ],
        settings: {
            onPaginate: (pageInfo) => this.changePage(pageInfo),
            onOrderBy: (columnName) => this.orderBy(columnName),
            canConfirmOrder: false,
            totalElements: null,
            promise: null,
            minimizable: true,
            minimizedOnInit: false,
            hidePaginator: true
        }
    };

    searchResult;

    //--- Constructor -------------------------------------------------
    constructor(private toastService, private Orders, private $scope, private $filter: IFilterService,
                private $state: IStateService, private $location: ILocationService, private urlService: UrlService,
                private hasAccessTo) {
        this.tableDefinition.settings.canConfirmOrder = hasAccessTo.orderConfirmation();
        _.times(150, (i: number) => this.yearSelectOptions.push(1950 + i));
    }


    changePage(pageInfo) {
        this.activeSearchParams.pageNo = pageInfo.page - 1;
        this.activeSearchParams.pageSize = pageInfo.limit;
    }

    orderBy(columnName) {
        var descending = columnName[0] === '-';
        columnName = descending ? columnName.slice(1, columnName.length) : columnName;
        var orderDirection = descending ? "desc" : "asc";
        this.activeSearchParams.sort = columnName + "|" + orderDirection;
    }

    ordersSearch(paramsWithFormattedDates) {
        this.searchResult = null;
        this.activeSearchParams = paramsWithFormattedDates;
        this.tableDefinition.settings.promise = this.Orders.search(paramsWithFormattedDates).$promise.then(
            (results) => this.processResults(results),
            (error) => this.processError(error)
        );
    }

    getCanDeliverEarlierOrders() {
        this.searchResult = null;
        this.activeSearchParams = this.searchDefinition.searchParams;
        this.tableDefinition.settings.promise = this.Orders.canDeliverEarlierOrders(this.searchDefinition.searchParams, {}).$promise.then(
            (results) => this.processResults(results),
            (error) => this.processError(error)
        );
    }

    getCantDeliverOrders() {
        this.searchResult = null;
        this.activeSearchParams = this.searchDefinition.searchParams;
        this.tableDefinition.settings.promise = this.Orders.cantDeliverOrders(this.searchDefinition.searchParams, {}).$promise.then(
            (results) => this.processResults(results),
            (error) => this.processError(error)
        );
    }

    getSplitOrders() {
        this.searchResult = null;
        this.activeSearchParams = this.searchDefinition.searchParams;
        this.tableDefinition.settings.promise = this.Orders.splitOrders(this.searchDefinition.searchParams, {}).$promise.then(
            (results) => this.processResults(results),
            (error) => this.processError(error)
        );
    }

    getUnconfirmedOrders() {
        this.searchResult = null;
        this.activeSearchParams = this.searchDefinition.searchParams;
        this.tableDefinition.settings.promise = this.Orders.unconfirmedOrders(this.searchDefinition.searchParams, {}).$promise.then(
            (result) => this.processResults(result),
            (error) => this.processError(error)
        );
    }

    emptyWeekData() {
        this.datesInWeek = [];
        this.$scope.$broadcast('$emptyWeekData');
    }

    processResults(results) {
        this.datesInWeek = _.uniq(_.map(results['dates'], (value) => {
            return moment(value).isBefore(moment(), 'day') ? 'Historiske datoer' : value
        }));
        const result = {'Historiske datoer': []};
        _.forIn(results['ordersByDate'], (value, key) => {
            if (moment(key).isBefore(moment(), 'day')) {
                _.merge(result['Historiske datoer'], value);
            } else {
                result[key] = value;
            }
        });
        if (_.some(this.datesInWeek, (date: string) => result[date] && result[date].length)) {
            _.forEach(this.datesInWeek, date => _.forEach(result[date], result => {
                result.deliveryDate = result.deliveryDate ? new Date(result.deliveryDate) : null;
            }));
            this.tableDefinition.settings.minimizedOnInit = Object.keys(result).length > 7;
            this.searchResult = result;
        } else {
            this.toastService.showSimpleToast("Søket gav ingen resultater", 2000);
            this.searchResult = null;
        }
    }

    processError(error) {
        this.searchResult = null;
        this.toastService.parseError(error);
    }

    isDateNotToday(date) {
        return moment(0, "HH").diff(date, "days") != 0;
    }
}

class OrdersOptions implements ng.IComponentOptions {
    controllerAs = 'c';
    public controller: any =
        ['toastService', 'Orders', '$scope', '$filter', '$state', '$location', 'urlService', 'hasAccessTo',
            (toastService, Orders, $scope, $filter, $state, $location, urlService, hasAccessTo) =>
                new OrdersController(toastService, Orders, $scope, $filter, $state, $location, urlService, hasAccessTo)];
    public template: any = require('./orders.html');
}

rkcApp.component("rkcOrders", new OrdersOptions());



/** WEBPACK FOOTER **
 ** ./src/app/components/main/views/orders/orders.ts
 **/